var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19537_42467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19537_42467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2083 7.81272L16.0417 6.64605L16.6667 6.00022L14 3.33355L13.3542 3.95855L12.1667 2.77105L12.7917 2.12522C13.1111 1.80578 13.5069 1.64953 13.9792 1.65647C14.4514 1.66342 14.8472 1.82661 15.1667 2.14605L17.8542 4.83355C18.1736 5.153 18.3333 5.54536 18.3333 6.01064C18.3333 6.47592 18.1736 6.86828 17.8542 7.18772L17.2083 7.81272ZM7.20833 17.8336C6.88889 18.153 6.49653 18.3127 6.03125 18.3127C5.56597 18.3127 5.17361 18.153 4.85417 17.8336L2.16667 15.1461C1.84722 14.8266 1.6875 14.4342 1.6875 13.969C1.6875 13.5037 1.84722 13.1113 2.16667 12.7919L2.79167 12.1669L3.97917 13.3544L3.33333 13.9794L6.02083 16.6669L6.64583 16.0211L7.83333 17.2086L7.20833 17.8336ZM15.4792 10.8336L16.6667 9.64606L10.3542 3.33355L9.16667 4.52105L15.4792 10.8336ZM9.64583 16.6669L10.8333 15.4586L4.54167 9.16689L3.33333 10.3544L9.64583 16.6669ZM9.52083 11.7919L11.8125 9.52105L10.4792 8.18772L8.20833 10.4794L9.52083 11.7919ZM10.8333 17.8336C10.5139 18.153 10.1181 18.3127 9.64583 18.3127C9.17361 18.3127 8.77778 18.153 8.45833 17.8336L2.16667 11.5419C1.84722 11.2224 1.6875 10.8266 1.6875 10.3544C1.6875 9.88217 1.84722 9.48633 2.16667 9.16689L3.35417 7.97939C3.67361 7.65994 4.06597 7.50022 4.53125 7.50022C4.99653 7.50022 5.38889 7.65994 5.70833 7.97939L7.02083 9.29189L9.3125 7.00022L8 5.70855C7.68056 5.38911 7.52083 4.99328 7.52083 4.52105C7.52083 4.04883 7.68056 3.653 8 3.33355L9.1875 2.14605C9.50694 1.82661 9.89931 1.66689 10.3646 1.66689C10.8299 1.66689 11.2222 1.82661 11.5417 2.14605L17.8542 8.45856C18.1736 8.778 18.3333 9.17036 18.3333 9.63564C18.3333 10.1009 18.1736 10.4933 17.8542 10.8127L16.6667 12.0002C16.3472 12.3197 15.9514 12.4794 15.4792 12.4794C15.0069 12.4794 14.6111 12.3197 14.2917 12.0002L13 10.6877L10.7083 12.9794L12.0208 14.2919C12.3403 14.6113 12.5 15.0037 12.5 15.469C12.5 15.9342 12.3403 16.3266 12.0208 16.6461L10.8333 17.8336Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.7d130b0d3ca5859b3a5cc0a38faf529b.svg";
export { ForwardRef as ReactComponent };